import React from "react";

export default function PaymentConfirmationPage() {
  return (
    <div style={{ maxWidth: 480, margin: "40px auto", padding: 24, textAlign: "center" }}>
      <h2 style={{ color: "#3182ce", marginBottom: 18 }}>Payment Successful!</h2>
      <p>Thank you for subscribing. Your payment has been received and your subscription is now active.</p>
      <p>We will contact you soon to arrange your first collection and delivery.</p>
      <div style={{ marginTop: 32 }}>
        <a href="/" className="btn btn-primary">Go to Home</a>
      </div>
    </div>
  );
}
